import { render, staticRenderFns } from "./GeneralReporting.vue?vue&type=template&id=383e2fcd&scoped=true&"
import script from "./GeneralReporting.vue?vue&type=script&lang=js&"
export * from "./GeneralReporting.vue?vue&type=script&lang=js&"
import style0 from "./GeneralReporting.vue?vue&type=style&index=0&id=383e2fcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e2fcd",
  null
  
)

export default component.exports